import type { PaymentInstruction, PaymentMethodCategory } from 'src/types/common';

export const BUS_AKAP_FACILITIES = [
  {
    icon: 'iconoir:tv',
    title: 'LCD TV',
  },
  {
    icon: 'lucide:air-vent',
    title: 'AC',
  },
  {
    icon: 'cil:toilet',
    title: 'Toilet',
  },
  {
    icon: 'lucide:music',
    title: 'Entertaimnet',
  },
  {
    icon: 'game-icons:pillow',
    title: 'Bantal Leher',
  },
  {
    icon: 'game-icons:blanket',
    title: 'Selimut',
  },
  {
    icon: 'fluent:food-48-regular',
    title: 'Voucher Makan',
  },
  {
    icon: 'icon-park-solid:snacks',
    title: 'Snack',
  },
  {
    icon: 'ant-design:usb-twotone',
    title: 'USB Port',
  },
  {
    icon: 'hugeicons:seat-selector',
    title: '30 Seats',
  },
  {
    icon: 'icon-park-outline:baby-car-seat',
    title: 'Leg Rest',
  },
  {
    icon: 'mdi:car-child-seat',
    title: 'Recycling Seat',
  },
];

export const PAYMENT_METHODS: PaymentMethodCategory[] = [
  {
    title: 'Bank Transfer',
    paymentMethod: [
      {
        image: '/assets/images/payments/bca.png',
        title: 'Bank Central Asia',
        description: 'Transfer ke BCA',
        paymentMethod: 'bank_transfer',
        paymentChannel: 'bca',
      },
      {
        image: '/assets/images/payments/bni.png',
        title: 'Bank Negara Indonesia',
        description: 'Transfer ke BNI',
        paymentMethod: 'bank_transfer',
        paymentChannel: 'bni',
      },
      {
        image: '/assets/images/payments/bri.png',
        title: 'Bank Rakyat Indonesia',
        description: 'Transfer ke BRI',
        paymentMethod: 'bank_transfer',
        paymentChannel: 'bri',
      },
      {
        image: '/assets/images/payments/mandiri.png',
        title: 'Bank Mandiri',
        description: 'Transfer ke Bank Mandiri',
        paymentMethod: 'bank_transfer',
        paymentChannel: 'mandiri',
      },
      {
        image: '/assets/images/payments/permata.png',
        title: 'Bank Permata',
        description: 'Transfer ke Bank Permata',
        paymentMethod: 'bank_transfer',
        paymentChannel: 'permata',
      },
    ],
  },
  {
    title: 'E-Wallet',
    paymentMethod: [
      {
        image: '/assets/images/payments/qris.png',
        title: 'QRIS',
        description: 'Transfer pakai QRIS',
        paymentMethod: 'qris',
      },
      {
        image: '/assets/images/payments/gopay.png',
        title: 'Gopay',
        description: 'Transfer pakai Gopay',
        paymentMethod: 'gopay',
      },
    ],
  },
  // {
  //   title: 'Retail Payment',
  //   paymentMethod: [
  //     {
  //       image: '/assets/images/payments/alfamart.png',
  //       title: 'Alfamart',
  //       description: 'Transfer melalui Alfamart',
  //       paymentMethod: 'alfamart',
  //     },
  //     {
  //       image: '/assets/images/payments/indomaret.png',
  //       title: 'Indomaret',
  //       description: 'Transfer melalui Indomaret',
  //       paymentMethod: 'indomaret',
  //     },
  //   ],
  // },
];

export const PAYMENT_INSTRUCTIONS: PaymentInstruction[] = [
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'bca',
    title: 'ATM BCA',
    instructions: [
      'Pilih transaksi lainnya pada menu utama.',
      'Pilih transfer.',
      'Pilih ke rekening BCA virtual account.',
      'Masukkan nomor BCA virtual account.',
      'Pastikan jumlah yang akan dibayar sudah benar, atau masukkan jumlahnya secara manual, lalu konfirmasi.',
      'Pembayaran selesai.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'bca',
    title: 'Klik BCA',
    instructions: [
      'Pilih Transfer Dana.',
      'Pilih Transfer ke BCA virtual account.',
      'Masukkan nomor BCA virtual account.',
      'Pastikan jumlah yang akan dibayar sudah benar, atau masukkan jumlahnya secara manual, lalu konfirmasi.',
      'Pembayaran selesai.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'bca',
    title: 'm-BCA',
    instructions: [
      'Pilih m-Transfer.',
      'Pilih BCA virtual account.',
      'Masukkan nomor BCA virtual account.',
      'Masukkan jumlah yang akan dibayar, lalu konfirmasi.',
      'Pembayaran selesai.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'bca',
    title: 'Via bank lainnya',
    instructions: [
      'Pilih bank & cara bayar (ATM/internet/mobile banking) yang Anda inginkan.',
      'Pilih transfer ke bank lain.',
      'Masukkan nomor virtual account BCA.',
      'Masukkan jumlah yang akan dibayar, lalu konfirmasi.',
      'Pembayaran selesai.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'bri',
    title: 'ATM BRI',
    instructions: [
      'Pilih transaksi lainnya pada menu utama.',
      'Pilih transfer.',
      'Pilih ke rekening BRI.',
      'Masukkan nomor rekening pembayaran.',
      'Masukkan jumlah yang akan dibayar, lalu konfirmasi.',
      'Pembayaran selesai.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'bri',
    title: 'BRI Internet Banking',
    instructions: [
      'Pilih transaksi, lalu info & administrasi transfer.',
      'Pilih atur rekening tujuan.',
      'Masukkan informasi rekening, lalu konfirmasi.',
      'Pilih transfer, lalu transfer ke rekening BRI.',
      'Masukkan detail pembayaran, lalu konfirmasi.',
      'Pembayaran selesai.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'bri',
    title: 'BRI Mobile Banking',
    instructions: [
      'Pilih transfer.',
      'Pilih virtual account billing.',
      'Pilih rekening debit yang akan digunakan.',
      'Masukkan nomor virtual account, lalu konfirmasi.',
      'Pembayaran selesai.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'bri',
    title: 'Via bank lainnya',
    instructions: [
      'Pilih bank & cara bayar (ATM/internet/mobile banking) yang Anda inginkan.',
      'Pilih transfer ke bank lain.',
      'Masukkan nomor virtual account BRI.',
      'Masukkan jumlah yang akan dibayar, lalu konfirmasi.',
      'Pembayaran selesai.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'permata',
    title: 'Via rekening Permata',
    instructions: [
      'Pilih transaksi lainnya pada menu utama.',
      'Pilih pembayaran.',
      'Pilih pembayaran lainnya.',
      'Pilih virtual account.',
      'Masukkan nomor virtual account Permata, lalu konfirmasi.',
      'Pembayaran selesai.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'permata',
    title: 'Via bank lainnya',
    instructions: [
      'Pilih bank & cara bayar (ATM/internet/mobile banking) yang Anda inginkan.',
      'Pilih transfer ke bank lain.',
      'Masukkan nomor virtual account.',
      'Masukkan jumlah yang akan dibayar, lalu konfirmasi.',
      'Pembayaran selesai.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'bni',
    title: 'ATM BNI',
    instructions: [
      'Pilih menu lain pada menu utama.',
      'Pilih transfer.',
      'Pilih ke rekening BNI.',
      'Masukkan nomor rekening pembayaran.',
      'Masukkan jumlah yang akan dibayar, lalu konfirmasi.',
      'Pembayaran selesai.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'bni',
    title: 'BNI Internet Banking',
    instructions: [
      'Pilih transaksi, lalu info & administrasi transfer.',
      'Pilih atur rekening tujuan.',
      'Masukkan informasi rekening, lalu konfirmasi.',
      'Pilih transfer, lalu transfer ke rekening BNI.',
      'Masukkan detail pembayaran, lalu konfirmasi.',
      'Pembayaran selesai.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'bni',
    title: 'BNI Mobile Banking',
    instructions: [
      'Pilih transfer.',
      'Pilih virtual account billing.',
      'Pilih rekening debit yang akan digunakan.',
      'Masukkan nomor virtual account, lalu konfirmasi.',
      'Pembayaran selesai.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'bni',
    title: 'Via bank lainnya',
    instructions: [
      'Pilih bank & cara bayar (ATM/internet/mobile banking) yang Anda inginkan.',
      'Pilih transfer ke bank lain.',
      'Masukkan nomor virtual account BNI.',
      'Masukkan jumlah yang akan dibayar, lalu konfirmasi.',
      'Pembayaran selesai.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'mandiri',
    title: 'ATM Mandiri',
    instructions: [
      'Masukkan kartu ATM dan PIN Anda.',
      'Pilih menu Bayar/Beli > Lainnya > Multi Payment.',
      'Masukkan kode perusahaan dan nomor Virtual Account yang diberikan.',
      'Periksa detail pembayaran dan konfirmasikan.',
      'Simpan struk sebagai bukti pembayaran.',
    ],
  },
  {
    paymentMethod: 'bank_transfer',
    paymentChannel: 'mandiri',
    title: 'Mandiri Online (Internet/Mobile Banking)',
    instructions: [
      'Login ke aplikasi Mandiri Online.',
      'Pilih menu Bayar > Multi Payment.',
      'Masukkan penyedia jasa dan nomor Virtual Account.',
      'Konfirmasikan detail dan masukkan PIN Anda.',
    ],
  },
  {
    paymentMethod: 'qris',
    title: 'QRIS',
    instructions: [
      'Buka aplikasi pembayaran yang mendukung QRIS (misalnya, GoPay, OVO, DANA).',
      "Pilih menu 'Scan QR' atau 'Bayar dengan QR'.",
      'Pindai kode QR yang ditampilkan pada halaman pembayaran.',
      'Periksa detail pembayaran yang muncul.',
      'Konfirmasikan pembayaran dan masukkan PIN atau autentikasi yang diperlukan.',
      'Setelah transaksi berhasil, Anda akan menerima notifikasi pembayaran.',
    ],
  },
  {
    paymentMethod: 'ewallet',
    paymentChannel: 'gopay',
    title: 'GoPay',
    instructions: [
      'Buka aplikasi Gojek dan pastikan saldo GoPay mencukupi.',
      "Pilih menu 'Bayar'.",
      'Pindai kode QR yang ditampilkan pada halaman pembayaran atau masukkan nomor Virtual Account yang diberikan.',
      'Periksa detail pembayaran yang muncul.',
      'Konfirmasikan pembayaran dan masukkan PIN GoPay Anda.',
      'Setelah transaksi berhasil, Anda akan menerima notifikasi pembayaran.',
    ],
  },
  {
    paymentMethod: 'alfamart',
    title: 'Alfamart',
    instructions: [
      'Kunjungi gerai Alfamart terdekat.',
      'Informasikan kepada kasir bahwa Anda ingin melakukan pembayaran untuk layanan tertentu.',
      'Berikan kode pembayaran atau nomor referensi yang diperlukan kepada kasir.',
      'Kasir akan memproses pembayaran Anda.',
      'Lakukan pembayaran sesuai jumlah yang diinformasikan oleh kasir.',
      'Simpan struk sebagai bukti pembayaran.',
    ],
  },
  {
    paymentMethod: 'indomaret',
    title: 'Indomaret',
    instructions: [
      'Kunjungi gerai Indomaret terdekat.',
      'Informasikan kepada kasir bahwa Anda ingin melakukan pembayaran untuk layanan tertentu.',
      'Berikan kode pembayaran atau nomor referensi yang diperlukan kepada kasir.',
      'Kasir akan memproses pembayaran Anda.',
      'Lakukan pembayaran sesuai jumlah yang diinformasikan oleh kasir.',
      'Simpan struk sebagai bukti pembayaran.',
    ],
  },
];

export const PROVINCES = [
  {
    name: 'Lampung',
    value: 'Lampung',
    image_asset: '/assets/images/image-lampung.webp',
  },
  {
    name: 'Jawa Tengah',
    value: 'Jawa Tengah',
    image_asset: '/assets/images/image-jateng.webp',
  },
  {
    name: 'Yogyakarta (D.I.Y)',
    value: 'Yogyakarta',
    image_asset: '/assets/images/image-yogyakarta.webp',
  },
  {
    name: 'Jawa Timur',
    value: 'Jawa Timur',
    image_asset: '/assets/images/image-jatim.webp',
  },
];
